import { interfaceEngine } from 'service/interfaces/config/engine'
import { interfaceTypeVehicle } from 'service/interfaces/config/typevechicle'
import { configUsersInterface } from 'service/interfaces/config/users'
import { operatorsInterface } from 'service/interfaces/config/various/operators'
import { ecoSoft } from 'service/interfaces/ecosoft'
import { plantChecklist } from 'service/interfaces/plant/Checklist'
import { plantDespatch } from 'service/interfaces/plant/Despatch'
import { plantOrders } from 'service/interfaces/plant/Orders'
import { plantStation } from 'service/interfaces/plant/Station'
import { plantInterfaceStock } from 'service/interfaces/plant/stock'
import { plantStorage } from 'service/interfaces/plant/storage'
import { plantUsed } from 'service/interfaces/plant/used'
import { salesClients } from 'service/interfaces/sales/clients'
import { salesOrders } from 'service/interfaces/sales/orders'
import { salesPaymentOrders } from 'service/interfaces/sales/paymentOrders'
import { salesPrice } from 'service/interfaces/sales/price'
import { salesStock } from 'service/interfaces/sales/stock'
import { salesSuppliers } from 'service/interfaces/sales/suppliers'
import { compactionInterface } from 'service/interfaces/vehicles/compaction'
import { quotationsInterface } from 'service/interfaces/vehicles/quotations'

import { accounting } from './accounting/check'
import { conceptsInterface } from './config/various/concepts'
import { plantInterfaceClassification } from './plant/Classification'
import { plantCompaction } from './plant/Compaction'
import { salesCaja } from './sales/caja'
import { salesCobranzas } from './sales/cobranzas'
import { salesReceipt } from './sales/receipt'
import { vehicleInterface } from './vehicles/searchvehicles'
import { wafersInterface } from './vehicles/searchwafers'
import { transitInterface } from './vehicles/vehicletransit'
import { wafersWithControlInterface } from './vehicles/waferswithcontrol'
import { configInterface } from './config'
import { dashboardInterface } from './dashboard'
import { logInInterface } from './login'

export const interfaces = {
  vehicleInterface,
  quotationsInterface,
  dashboardInterface,
  logInInterface,
  wafersInterface,
  transitInterface,
  configInterface,
  interfaceEngine,
  plantInterfaceClassification,
  plantInterfaceStock,
  plantCompaction,
  plantStorage,
  plantChecklist,
  configUsersInterface,
  plantOrders,
  operatorsInterface,
  plantDespatch,
  salesStock,
  plantUsed,
  plantStation,
  ecoSoft,
  salesPrice,
  salesClients,
  salesPaymentOrders,
  interfaceTypeVehicle,
  conceptsInterface,
  compactionInterface,
  salesSuppliers,
  salesOrders,
  accounting,
  wafersWithControlInterface,
  salesCobranzas,
  salesReceipt,
  salesCaja,
}
